import history from '../../history';
import { showToaster } from '../../helpers/toastrMessgaes/showToaster';
import { updateHomePageCategoryMutation as mutation } from '../../lib/graphql';

export const updateHomePageCategory = ({ categoryList }) => {
    try {

        let title, description;
        title = categoryList?.title[0]?.title;
        description = categoryList?.title[0]?.description;

        return async (dispatch, getState, { client }) => {
            const { data } = await client.mutate({
                mutation,
                variables: {
                    homePageCategoryList: {
                        id: categoryList?.id,
                        title,
                        description,
                        logo: categoryList?.logo,
                        banner: categoryList?.banner,
                    },
                    dynamicTopFeatureSettings: categoryList?.title
                }
            });

            if (data?.updateHomePageCategory?.status == 200) {
                showToaster({ messageId: 'changesUpdated', toasterType: 'success' });
                history.push('/siteadmin/homepage/top-feature');
            } else {
                showToaster({ messageId: 'errorMessage', requestContent: { content: data?.updateHomePageCategory?.errorMessage }, toasterType: 'error' });
            }
        };
    }
    catch (error) {
        showToaster({ messageId: 'catchMessage', requestContent: { content: error }, toasterType: 'error' });
    }
}